<template>
<div class="note" style="position: relative">
  <div class="heading" :class="type">
    <span class="text--l text--bold">{{noteTypes[type]}}</span>
  </div>
  <div class="list" v-html="content" />
  <div class="color-bar" :class="type" />
</div>
</template>

<script>
export default {
  name: "Note",
  props: {
    content: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: function (value) {
        // The value must match one of these strings
        return ['do', 'dont', 'info'].includes(value)
      }
    }
  },
  data: () => ({
    noteTypes: {
      "info": 'Info',
      "do": 'Do',
      "dont": `Don't`
    }
  })
}
</script>

<style lang="scss" scoped>
@import "~@/styles/SelfService/colors.scss";
@import "~@/styles/SelfService/spacing.scss";

.note{
  position: relative;
  padding-left: $spacing--l;

  .heading {
    margin-bottom: 16px;

    &.info {
      color: $focus;
    }
    &.do {
      color: $success;
    }
    &.dont {
      color: $error;
    }
  }
}

.color-bar{
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 8px;
  border-radius: 4px;

  &.info {
    background-color: $focus;
  }
  &.do {
    background-color: $success;
  }
  &.dont {
    background-color: $error;
  }
}

.list ::v-deep ul{
    li {
      margin-bottom: 10px;
    }

    li:last-child {
      margin-bottom: 0px;
    }
}

</style>
